/* eslint-disable indent */
const TRY_COUNTER = __isDev__ ? 0 : 5;

const EventNamesPerLocation = {
    'business/instant-account-payout': 'linkedin_b2b_ent_button',
};

export const getEventNameFromUrl = (pathname) => {
    for (const [key, value] of Object.entries(EventNamesPerLocation)) {
        if (pathname.includes(key)) {
            return value;
        }
    }
};

export const initGoogleAnalytics = (analytics) => {
    const gaTrackingID = process.env.GOOGLE_TRACKING_ID;
    const gaTagManagerID = process.env.GOOGLE_TAG_MANAGER_ID;
    if (analytics && gaTrackingID && gaTagManagerID) {
        const tagManager = analytics;
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            (i[r] =
                i[r] ||
                function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }),
                (i[r].l = 1 * new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = true;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

        // Initialization.
        ga('create', gaTrackingID, 'auto');
        ga('send', 'pageview');

        //Init ecommerce
        ga('require', 'ecommerce');
        ga(function (tracker) {
            var AnclientId = tracker.get('clientId');
            ga('set', 'dimension1', AnclientId);
            ga('send', 'event', 'Anclientid', 'senddimension', { nonInteraction: true });
        });

        // if ($('.js__ga_async').length > 0) {
        // ga('set', 'dimension2', $('.js__ga_async').data("transactionType"));
        // ga('set', 'dimension3', $('.js__ga_async').data("countryFrom"));
        // ga('set', 'dimension4', $('.js__ga_async').data("countryFrom"));
        // ga('set', 'dimension5', $('.js__ga_async').data("paymentId"));
        // ga('send', 'event', 'sendtransaction', 'senddimension', {nonInteraction: true});
        // }
        if (tagManager) {
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js',
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', gaTagManagerID);
        }
    }
};

export const sendGa = (eventName, actionDesc) => {
    if (__isDev__) {
        console.log(`ga: ${eventName}, desc: ${actionDesc}`);
    }
    if (typeof ga !== 'undefined' && ga !== undefined) {
        ga('send', 'event', eventName, actionDesc);
    }
};

export const sendGtEvent = (value, params) => {
    let timerId = null;
    let counter = 1;
    if (typeof dataLayer !== 'undefined') {
        pushGtEvent(value, params);
    } else {
        timerId = setInterval(() => pushGtEvent(value, params, counter++, timerId), 700);
    }
};

const pushGtEvent = (value, params, counter, timerId) => {
    if (typeof dataLayer !== 'undefined') {
        const event = { event: value };
        if (params) {
            event.parameters = params;
        }
        dataLayer.push(event);
        if (__isDev__) {
            console.log('GT event', event);
        }
        clearInterval(timerId);
    } else if (counter >= TRY_COUNTER) {
        clearInterval(timerId);
    }
};

export const getLibreFAQParam = (question_id) => {
    switch (question_id) {
        case 289:
            return 'how_accept';
        case 291:
            return 'how_spend';
        case 292:
            return 'how_secure';
        case 293:
            return 'paysend_card';
        case 294:
            return 'how_get_card';
        case 295:
            return 'is_card_free';
        case 296:
            return 'is_card_card secure';
        default:
            return null;
    }
};
